import {
    FormControl,
    FormHelperText,
    InputAdornment,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { FormikProps } from 'formik';
import { isError, showHelperText } from '../../commercial/Switch/utils';
import en from '../../../../lang/en-us';
import { InstallmentFieldsType } from './types';
import { getSipDays } from '../ExploreMFs/mf-helpers';
import {
    calculateInstallment,
    endDateDisable,
    handleCalendarView,
    MAX_DATE,
    startDateDisable,
} from '../utils';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import DatePickerInput from '../../../../lib/DatePicker';
import useSip, { freqType } from '../../../../hooks/useSip';
import { DEFAULT_MIN_TAT, isNumber } from '../../../../utils/constants';
import { showHintTemplateForMaxAndMin } from '../ExploreMFs/Validations';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import { useEffect, useState } from 'react';
import { CustomRadio } from '../../../../lib/CustomRadio';
import { rtaNames } from '../../../common/FatcaCheck.types';
import { RTA_CODES } from '../emandate/types';

const { dbCommercial } = en;

type PropsType = {
    formik: FormikProps<InstallmentFieldsType>;
    schemeDetails: any;
    rtaName: string;
    swpFlag?: boolean;
    setInstallmentDiff: any;
};

export default function InstallmentFields({
    formik,
    schemeDetails,
    swpFlag = false,
    setInstallmentDiff,
    rtaName,
}: PropsType) {
    const [errors, setErrors] = useState({ dateError: false });
    const [startDate, endDate, setStartDate, setEndDate, resetEndDate, installment_diff] = useSip({
        frequencyType: formik.values.frequency || 'Monthly',
        numInstallments: formik.values.numInstallments,
        kfinFlag: rtaName === RTA_CODES.KFIN,
        stpFlag: false,
        sipDay: formik.values.installmentDay,
        sipTat:
            !!schemeDetails && !!Number(schemeDetails[formik.values.frequency as string]?.minSipTat)
                ? Number(schemeDetails[formik.values.frequency as string]?.minSipTat)
                : DEFAULT_MIN_TAT,
        perpetual: formik.values.perpetual,
        setErrors,
    });

    useEffect(() => {
        setInstallmentDiff(installment_diff);
    }, [installment_diff]);

    useEffect(() => {
        formik.setFieldValue('installmentError', errors.dateError);
    }, [errors]);

    useEffect(() => {
        const installmentKey =
            !!schemeDetails &&
            formik.values.frequency &&
            schemeDetails[formik.values.frequency as string]?.minimumInstallments[
                calculateInstallment(installment_diff, schemeDetails, formik.values)
            ];
        const sipDay = getSipDays(
            !!schemeDetails
                ? schemeDetails[!!formik.values.frequency ? formik.values.frequency : 'Monthly']
                      ?.dates || []
                : [],
        )[0];
        formik.setFieldValue('installmentKey', {
            ...installmentKey,
            minAmount: Math.max(1, installmentKey?.minAmount || 1),
        });
        formik.setFieldValue('numInstallments', !!installmentKey ? installmentKey.installment : 1);
        formik.setFieldValue('installmentDay', sipDay);
        if (!!schemeDetails && !!schemeDetails[formik.values.frequency]?.multiples) {
            formik.setFieldValue(
                'multiples',
                Math.max(schemeDetails[formik.values.frequency]?.multiples, 1),
            );
        }
    }, [formik.values.frequency, schemeDetails]);

    useEffect(() => {
        formik.setFieldValue('fromDate', startDate);
        if (!formik.values.perpetual) {
            formik.setFieldValue('toDate', endDate);
        }
    }, [startDate, endDate]);

    return (
        <div className="investment-details-content">
            {/* {!swpFlag && (
                <div className="radio-div block-view">
                    <p>{dbCommercial.stp.stpType}</p>
                    <CustomRadio
                        name="stpType"
                        helperText={showHelperText(formik, 'stpType')}
                        error={isError(formik, 'stpType')}
                        list={[
                            {
                                label: dbCommercial.stp.fixed,
                                value: 'F',
                            },
                            {
                                label: dbCommercial.stp.variable,
                                value: 'V',
                            },
                        ]}
                        selectedValue={formik.values.stpType}
                        handleRadioChange={(value: any) => {
                            formik.setFieldValue('stpType', value);
                        }}
                    />
                </div>
            )} */}
            <div className="investment-amount" style={{ display: 'flex', alignItems: 'start' }}>
                <p style={{ marginBottom: '0', marginTop: '20px' }}>
                    {swpFlag
                        ? dbCommercial.exploreMfs.mfInvestment.swpAmount
                        : dbCommercial.exploreMfs.mfInvestment.stpAmount}
                </p>
                <TextField
                    id="enter-arn"
                    variant="outlined"
                    error={isError(formik, 'amount')}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        if (!isNumber(event.target.value) || event.target.value.length > 18) return;
                        formik.setFieldValue('amount', event.target.value);
                    }}
                    helperText={
                        !!schemeDetails
                            ? showHintTemplateForMaxAndMin({
                                  min: formik.values.installmentKey.minAmount,
                                  max: formik.values.installmentKey.maxAmount,
                                  multiples: Math.max(
                                      schemeDetails[formik.values.frequency]?.multiples,
                                      1,
                                  ),
                              })
                            : ''
                    }
                    value={formik.values.amount}
                    name="amount"
                    // InputProps={{
                    //     startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                    // }}
                />
            </div>
            <div className="investment-amount-select">
                <FormControl variant="filled" className="mf-investment-select">
                    <p>{dbCommercial.exploreMfs.mfInvestment.frequency}</p>
                    <Select
                        labelId="frequency-label"
                        id="frequency"
                        value={formik.values.frequency}
                        error={isError(formik, 'frequency')}
                        onChange={(e) => {
                            formik.setFieldValue('frequency', e.target.value);
                        }}
                    >
                        {!!schemeDetails &&
                            Object.keys(schemeDetails).map((option: string) => (
                                <MenuItem value={option}>{option}</MenuItem>
                            ))}
                    </Select>
                    <FormHelperText style={{ color: 'red', padding: 0, fontSize: 12 }}>
                        {showHelperText(formik, 'frequency')}
                    </FormHelperText>
                </FormControl>
                <FormControl variant="filled" className="mf-investment-select">
                    <p>
                        {swpFlag
                            ? dbCommercial.exploreMfs.mfInvestment.selectSwpDay
                            : dbCommercial.exploreMfs.mfInvestment.selectStpDay}
                    </p>
                    <Select
                        labelId="select-sip-label"
                        id="select-sip"
                        value={formik.values.installmentDay || new Date().getDate()}
                        onChange={(e: any) => {
                            formik.setFieldValue('installmentDay', e.target.value);
                        }}
                    >
                        {!!schemeDetails &&
                            getSipDays(schemeDetails[formik.values.frequency]?.dates || [])?.map(
                                (val: number) => {
                                    return <MenuItem value={val}>{val}</MenuItem>;
                                },
                            )}
                    </Select>
                </FormControl>
            </div>
            <div className="sip-run-time">
                <DatePickerInput
                    className="sip-date-input"
                    label="Start Date"
                    value={formik.values.fromDate}
                    disableFuture={false}
                    disablePast={true}
                    maxDate={MAX_DATE}
                    onChange={(e: any) => {
                        formik.setFieldValue('fromDate', e || new Date());
                        setStartDate(e);
                    }}
                    helperText={`No. of Installments is ${installment_diff + 1}`}
                    shouldDisableDate={(day: MaterialUiPickersDate) => {
                        return startDateDisable(
                            day,
                            schemeDetails,
                            formik.values,
                            new Date(formik.values.fromDate),
                            false,
                            rtaName === RTA_CODES.KFIN,
                        );
                    }}
                />
                <DatePickerInput
                    className="sip-date-input"
                    disablePast={true}
                    label="End Date"
                    value={formik.values.toDate}
                    error={isError(formik, 'toDate')}
                    maxDate={MAX_DATE}
                    disabled={formik.values.perpetual}
                    onChange={(e) => {
                        formik.setFieldValue('toDate', e || new Date());
                        setEndDate(e || new Date());
                    }}
                    helperText={`Minimum Installments is ${
                        formik.values.installmentKey.installment || 1
                    }`}
                    disableFuture={false}
                    shouldDisableDate={(day: MaterialUiPickersDate) => {
                        return endDateDisable(
                            day,
                            schemeDetails,
                            formik.values,
                            new Date(formik.values.fromDate),
                            new Date(formik.values.toDate),
                            false,
                            rtaName === RTA_CODES.KFIN,
                        );
                    }}
                    views={
                        !!formik.values.frequency
                            ? handleCalendarView(formik.values.frequency as freqType)
                            : ['year', 'month', 'date']
                    }
                />
                <CheckBoxField
                    label="Perpetual"
                    value={formik.values.perpetual}
                    onChange={() => {
                        const perpetualDate = new Date(2099, 11, 31);
                        !formik.values.perpetual
                            ? formik.setFieldValue('toDate', perpetualDate)
                            : resetEndDate();
                        formik.setFieldValue('perpetual', !formik.values.perpetual);
                    }}
                />
            </div>
        </div>
    );
}
